exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mp-property-filter-menu {\n  display: inline-flex;\n}\n:host {\n  display: inline-flex;\n}\n.mp-property-filter-menu {\n  position: relative;\n}\n.mp-property-filter-menu mp-properties-menu {\n  max-height: 340px;\n}\n", ""]);

// exports
